export default class GenericUtils {
  /**
   * Return a random integer between min (included) and max (included)
   */
  static getRandomInt(min: number, max: number): number {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  /**
   * Escape a string to be usable to construct a RegExp
   */
  static escapeRegexString(string: string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
  }

  /**
   * Return the real typeof of the operand, unlike native typeof.
   *
   * https://shamansir.github.io/JavaScript-Garden/#types.typeof
   */
  static realTypeOf(value: any) {
    return Object.prototype.toString.call(value).slice(8, -1).toLowerCase();
  }
}
